export interface BulkUpdateInspectionRequest {
  id: number
  revision: number
}

export function BulkUpdateInspectionRequestToJSON(
  value: BulkUpdateInspectionRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
